import React from "react";

import Select from "react-select";
import FilterFrame from "../filters/FilterFrame";
import OfferFrame from "./OfferFrame";
import OfferImage from "./OfferImage";
import MarketingBox from "../marketing/MarketingBox";
import ReactMap, { GeoSearch } from "../components/ReactMap";
import { useSelector, useDispatch } from "react-redux";
import {
  setNorthEast,
  setSearchOption,
  setSelectedDestination,
  setSouthWest,
} from "amadeusredux/lib/searchSlice";
import { search } from "amadeusredux/lib/api";
import { setOfferPage, setOfferSort } from "amadeusredux/lib/offersSlice";
import { crtobr, offerSortOptions, views } from "../utils";
import { PAGESIZE } from "../config";
import LoadBar from "../components/LoadBar";
import { setMap, setSidebar, setView } from "amadeusredux/lib/systemSlice";
import InfoPopup from "../components/InfoPopup";
import { sendLink2Agency } from "amadeusredux/lib/bookingSlice";
import { RiCloseFill } from "react-icons/ri";
import Popup from "reactjs-popup";

import {
  FormattedMessage,
  FormattedNumber,
  useIntl,
  FormattedDate,
} from "react-intl";
import SearchParameter from "../searchs/SearchParameter";
import {
  setOfferlistfilter,
  setOptionOperators,
} from "amadeusredux/lib/filterSlice";
import { FaHeart, FaList, FaSearch } from "react-icons/fa";

import { BsSuitHeartFill, BsSuitHeart } from "react-icons/bs";
import { getAdvertising } from "amadeusredux/lib/propertiesSlice";

const nf = new Intl.NumberFormat("de-DE");

let interval = undefined;

export default function OffersView(props) {
  const { searchFrame } = props;
  const dispatch = useDispatch();
  //
  const [hotelIdx, setHotelIdx] = React.useState(-1);
  const [showSearch, setShowSearch] = React.useState(false);
  const offerInfos = useSelector((state) => state.offers.offerInfos);
  const responseInfo = useSelector((state) => state.offers.responseInfo);
  const queryorder = useSelector((state) => state.offers.queryorder);
  const offerPage = useSelector((state) => state.offers.offerPage);
  const offerSort = useSelector((state) => state.offers.offerSort);
  const offerstopper = useSelector((state) => state.offers.offerstopper);
  const sidebar = useSelector((state) => state.system.sidebar);
  const view = useSelector((state) => state.system.view);
  const map = useSelector((state) => state.system.map);
  const features = useSelector((state) => state.system.features);
  const specialAmount = useSelector((state) => state.offers.specialAmount);
  const memo = useSelector((state) => state.offers.memo);
  const agencyprops = useSelector((state) => state.properties.agencyproperties);
  const [uploadStep, setUploadStep] = React.useState(0);
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [requestData, setRequestData] = React.useState({
    name: "",
    mail: "",
    phone: "",
    remark: "",
  });

  const selectedMarketingActions = useSelector(
    (state) => state.search.selectedMarketingActions
  );
  const marketingActions = useSelector(
    (state) => state.filter.marketingActions
  );

  const reservationoperatorsonly = useSelector(
    (state) => state.search.reservationoperatorsonly
  );
  const loading = useSelector((state) => state.system.loading);
  const specialRoomType = useSelector((state) => state.search.specialRoomType);
  const searchEnded = useSelector((state) => state.system.searchEnded);

  const optionOperators = useSelector((state) => state.filter.optionOperators);
  const offerlistfilter = useSelector((state) => state.filter.offerlistfilter);

  let offers = offerInfos.Offers ? offerInfos.Offers.Offer : [];
  let geodata = offerInfos.GeoDictionary;
  let hotels = offerInfos.HotelDictionary;
  let maxPrice = 0;
  let minPrice = Number.MAX_SAFE_INTEGER;

  React.useEffect(() => {
    if (document.getElementById("leftSidebar")) {
      dispatch(getAdvertising({ view: view, panel: "leftSidebar" }));
    }

    if (document.getElementById("rightSidebar")) {
      dispatch(getAdvertising({ view: view, panel: "rightSidebar" }));
    }
  }, [offerInfos]);

  let allma = marketingActions.map((e) => e.label).join();

  let selma = [...selectedMarketingActions];

  selma = selectedMarketingActions.filter((e) => allma.indexOf(e) > -1);

  if (selma.length > 0) {
    offers = offers.filter((e) => {
      let ct = 0;
      if (!Array.isArray(e.MarketingActions)) return false;
      if (Array.isArray(e.MarketingActions) && e.MarketingActions.length == 0)
        return false;
      for (let i = 0; i < e.MarketingActions.length; i++) {
        if (e.MarketingActions[i].MarketingProperties === null) continue;
        if (selma.includes(e.MarketingActions[i].MarketingProperties.label)) {
          //console.log(e.MarketingActions[i].MarketingProperties.text);
          ct++;
        }
      }
      return ct >= selma.length;
    });
  }

  if (reservationoperatorsonly) {
    offers = offers.filter((e) => {
      return (
        Array.isArray(optionOperators) &&
        optionOperators.find(
          (o) => o.touroperator === e.TourOperator?.TourOperatorCode
        )
      );
    });
  }
  //console.log(specialRoomType);

  let rnames = specialAmount.map((e) => e.value).join();

  let sprt = [...specialRoomType];

  sprt = sprt.filter((e) => rnames.indexOf(e) > -1);

  if (sprt.length > 0) {
    offers = offers.filter((e) => {
      let found = true;
      if (!Array.isArray(e.MarketingActions)) return false;
      if (e.MarketingActions.length < 1) return false;

      let roomnames = e.MarketingActions[0].roommouseovers;
      if (!roomnames) return false;

      for (let j = 0; j < sprt.length; j++) {
        if (roomnames.indexOf(sprt[j]) === -1) {
          found = false;
        }
      }

      return found;
    });
  }

  if (offers.length > 0) {
    if (Array.isArray(offers)) {
      for (let i = 0; i < offers.length; i++) {
        let offer = offers[i];
        if (offer.PriceInfo?.Price?.value) {
          if (
            minPrice >
            offer.PriceInfo.Price.value *
              (offer.adults * 1 + offer.children * 1)
          )
            minPrice =
              offer.PriceInfo.Price.value *
              (offer.adults * 1 + offer.children * 1);
          if (
            maxPrice <
            offer.PriceInfo.Price.value *
              (offer.adults * 1 + offer.children * 1)
          )
            maxPrice =
              offer.PriceInfo.Price.value *
              (offer.adults * 1 + offer.children * 1);
        }
      }
    }
  }

  React.useEffect(() => {
    if (
      Array.isArray(offers) &&
      offers.length > 0 &&
      Array.isArray(offers[0].displaydestination) &&
      offers[0].displaydestination.length > 0
    )
      document.title =
        (offers[0].displaydestination.length > 1
          ? "Reiseziele "
          : "Reiseziel ") +
        offers[0].displaydestination.map((e) => e.label).join(", ");
  }, [offers]);

  React.useEffect(() => {
    let offers = offerInfos.Offers ? offerInfos.Offers.Offer : [];
    if (offers.length === 0) return;
    let hotels = offerInfos.HotelDictionary
      ? offerInfos.HotelDictionary.Hotel
      : [];

    for (let i = 0; i < hotels.length; i++) {
      if (
        offers[0].OfferServices.Package.Accommodation.HotelRef.HotelID ===
        hotels[i].HotelID
      ) {
        setHotelIdx(i);
        break;
      }
    }
  }, [offerInfos]);

  /*let tmp = document.getElementsByClassName("dangerButton");
  if(tmp.length>0){
    for (let i=0;i<tmp.length;i++){
      tmp[i].onClick = (e) => console.log("erfolg");
    }
  }


  React.useEffect(() => {
    window.addEventListener("dangerButton", (e)=>console.log("erfolg"));
    return () => {
      window.removeEventListener("dangerButton", (e)=>console.log("erfolg"));
    };
  }, []);*/

  const changeFilterAndSearch = (property, value) => {
    setHotelIdx(-1);
    dispatch(setOfferPage(1));
    dispatch(setSearchOption({ property: property, data: value }));

    search(dispatch, false, false);
  };

  const changeClientFilter = (property, value) => {
    setHotelIdx(-1);
    dispatch(setOfferPage(1));
    dispatch(setSearchOption({ property: property, data: value }));
  };

  const dangerButtonHandler = (e, a) => {
    //console.log(a);
    a++;
    //console.log("drin");
    //console.log(e.target?e.target.nodeName:e.nodeName);
    if (e.target ? e.target.nodeName === "X" : e.nodeName === "X") {
      setUploadOpen(true);
    } else if (a < 5) {
      dangerButtonHandler(e.target ? e.target.parentNode : e.parentNode, a);
    }
  };

  let offersSorted = [...offers];

  if (offerSort.property === "price" && offerSort.order === "asc") {
    offersSorted.sort(
      (a, b) => a.PriceInfo?.Price?.value - b.PriceInfo?.Price?.value
    );
  }

  if (offerSort.property === "price" && offerSort.order === "desc") {
    offersSorted.sort(
      (a, b) => b.PriceInfo?.Price?.value - a.PriceInfo?.Price?.value
    );
  }

  if (offerSort.property === "recommendation" && offerSort.order === "asc") {
    offersSorted.reverse();
  }

  if (offerSort.property === "oursorting") {
    let tmpArray = [];
    if (queryorder.length > 0) {
      for (let i = 0; i < queryorder.length; i++) {
        let toadd = offersSorted.find(
          (off) => queryorder[i].offerid === off.OfferID
        );
        if (toadd) {
          //toadd.topseller = queryorder[i].topseller;
          tmpArray.push(toadd);
        }
      }
      if (tmpArray.length > 0) offersSorted = [...tmpArray];
      //response.data.BestPackageOfferForHotelRS.Offers.Offer = tmpArray;
    }
  }

  let filter = [];
  if (offerlistfilter) {
    let f = offerlistfilter.split(" ");
    for (let i = 0; i < f.length; i++) {
      f[i].trim();
      if (f[i].length > 0) {
        filter.push(f[i].trim().toUpperCase());
      }
    }
  }

  if (filter.length > 0 && Array.isArray(offersSorted)) {
    offersSorted = offersSorted.filter((offer) => {
      let check = false;
      if (offer.searchtext) {
        check = true;
        for (let i = 0; i < filter.length; i++) {
          if (!check) break;
          if (offer.searchtext.toUpperCase().indexOf(filter[i]) === -1) {
            check = false;
          }
        }
      }

      return check;
    });
  }

  const offersForPage = offersSorted.filter(
    (e, i) => i >= (offerPage - 1) * PAGESIZE && i < offerPage * PAGESIZE
  );

  //console.log(geodata, geodata?.Cities?.City, offerInfos.HotelDictionary);

  let country = "";
  if (
    Array.isArray(offerInfos?.HotelDictionary?.Hotel) &&
    offerInfos.HotelDictionary.Hotel.length > 0
  ) {
    country =
      offerInfos.HotelDictionary.Hotel[
        offerInfos.HotelDictionary.Hotel.length - 1
      ].HotelLocationRef.CountryCode;
  }

  let cities = [];
  if (Array.isArray(geodata?.Cities?.City))
    cities = geodata?.Cities?.City.filter((e) => e.CountryCode === country);

  //console.log("cities", cities);
  //console.log("country", country);

  let searchcity =
    Array.isArray(cities) && cities.length > 0
      ? " in " + cities[cities.length - 1].Name
      : "";

  return (
    <div className="offerview">
      <Popup modal closeOnDocumentClick={false} open={uploadOpen}>
        <div className="upload1 colordef">
          <div className="hotelinfoclose">
            <RiCloseFill
              onClick={() => {
                setUploadOpen(false);
                setUploadStep(0);
              }}
              style={{ fontSize: "1.5rem", margin: "auto" }}
            />
          </div>
          {uploadStep === 0 ? (
            <>
              <div className="upload2">
                Wir machen Ihnen gerne ein personalisiertes Angebot zu Ihrer
                Traumreise
              </div>
              <div className="upload10">
                <div>Name*</div>
                <input
                  className="upload3"
                  value={requestData.name}
                  onChange={(e) => {
                    setRequestData({
                      ...requestData,
                      name: e.target.value,
                    });
                  }}
                  type="text"
                ></input>
              </div>
              <div className="upload4">
                <div className="upload5">
                  <div>E-Mail**</div>
                  <input
                    className="upload7"
                    value={requestData.mail}
                    onChange={(e) => {
                      setRequestData({
                        ...requestData,
                        mail: e.target.value,
                      });
                    }}
                    type="text"
                  ></input>
                </div>
                <div className="upload6" />
                <div className="upload5">
                  <div>Telefon**</div>
                  <input
                    className="upload7"
                    value={requestData.phone}
                    onChange={(e) => {
                      setRequestData({
                        ...requestData,
                        phone: e.target.value,
                      });
                    }}
                    type="text"
                  ></input>
                </div>
              </div>
              <div className="upload10">
                <div>Zusätzliche Informationen</div>
                <textarea
                  className="upload8"
                  onChange={(e) => {
                    setRequestData({
                      ...requestData,
                      remark: e.target.value,
                    });
                  }}
                  value={requestData.remark}
                  type="text"
                ></textarea>
              </div>
              <div className="upload11">*erforderliche Daten</div>
              <div className="upload11">**Mail oder Telefon erforderlich</div>
              <div>
                <button
                  disabled={
                    !requestData.name ||
                    (!requestData.mail && !requestData.phone)
                  }
                  className={
                    requestData.name && (requestData.mail || requestData.phone)
                      ? "upload9"
                      : "upload9disabled"
                  }
                  onClick={() => {
                    setUploadStep(1);
                    console.log({
                      ...requestData,
                    });
                    dispatch(
                      sendLink2Agency({
                        ...requestData,
                      })
                    );
                  }}
                >
                  Senden
                </button>
              </div>
            </>
          ) : (
            <div>
              <div className="wrapper">
                {" "}
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  {" "}
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />{" "}
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
              </div>
              <div className="upload12">Vielen Dank</div>
              <div className="upload13">
                Ihre Anfrage wird schnellst möglich bearbeitet
              </div>
              <div>
                <button
                  className="upload9"
                  onClick={() => {
                    setUploadStep(0);
                    setUploadOpen(false);
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          )}
        </div>
      </Popup>
      {searchFrame}
      <SearchParameter />
      {/*{<div><div classname="offercityshortdescription">{crtobr(responseInfo.shortdescription)}</div>
        <div>Wissenswertes</div>
  <div classname="offercitylongdescription">{crtobr(responseInfo.longdescription)}</div></div>} */}
      <div className="offerview1">
        {/*<div className={sidebar ? "offerview2" : "offerview2collapsed"}>*/}

        <div className={sidebar ? "offerview2" : "offerview2"}>
          {Array.isArray(memo) && (
            <div
              className="memobutton"
              style={{ cursor: memo.length > 0 ? undefined : "auto" }}
              onClick={() => {
                if (memo.length === 0) return;
                let arr = [];
                for (let i = 0; i < memo.length; i++) {
                  arr.push({
                    label: memo[i].HotelName
                      ? memo[i].HotelName
                      : "Merkliste" + (i + 1),
                    HotelCodes: {
                      HotelGiataID: memo[i].HotelGiataID * 1,
                    },
                  });
                }

                dispatch(setSelectedDestination(arr));
                search(dispatch, false, false);
                dispatch(setView(views.offerview));
              }}
            >
              <div className="memoheartframe">
                <BsSuitHeartFill className="memoheart" />
              </div>
              <div className="memotextframe">
                Merkzettel{" "}
                <span style={{ fontSize: "0.5em" }}>({memo.length})</span>
              </div>
            </div>
          )}
          <FilterFrame
            minPrice={minPrice}
            maxPrice={maxPrice}
            hotel={false}
            changeClientFilter={changeClientFilter}
            changeFilterAndSearch={changeFilterAndSearch}
            travelfilter={true}
            hotelfilter={true}
          />
        </div>

        <div className="offerview3">
          <div className="offerviewheader">
            <Select
              className="offerviewselect"
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
              })}
              value={offerSort}
              onChange={(val) => {
                dispatch(setOfferPage(1));
                dispatch(setOfferSort(val));
              }}
              isSearchable={false}
              defaultValue={offerSortOptions[0]}
              options={offerSortOptions}
            />
            {offerSort.value === 0 &&
              Array.isArray(offers) &&
              offers.length > 0 &&
              offers[0].topseller === undefined &&
              agencyprops?.properties?.actionrecommendationsearchtext && (
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      agencyprops?.properties?.actionrecommendationsearchtext,
                  }}
                />
              )}
            {offerSort.value === 0 &&
              Array.isArray(offers) &&
              offers.length > 0 &&
              offers[0].topseller === undefined &&
              !agencyprops?.properties?.actionrecommendationsearchtext && (
                <b>
                  {" "}
                  <br />
                  Weitere Hotelangebote werden gesucht, unsere Empfehlungen und
                  Marketingaktionen werden zugeordnet... <br />
                </b>
              )}
            {offerSort.value !== 0 &&
              Array.isArray(offers) &&
              offers.length > 0 &&
              offers[0].topseller === undefined &&
              agencyprops?.properties?.actionsearchtext && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: agencyprops?.properties?.actionsearchtext,
                  }}
                />
              )}
            {offerSort.value !== 0 &&
              Array.isArray(offers) &&
              offers.length > 0 &&
              offers[0].topseller === undefined &&
              !agencyprops?.properties?.actionsearchtext && (
                <b>
                  {" "}
                  <br /> Weitere Hotelangebote werden gesucht, unsere
                  Marketingaktionen werden zugeordnet... <br />
                </b>
              )}
            {Array.isArray(offers) &&
              offers.length > 0 &&
              offers[0].topseller === undefined && <br />}
            <LoadBar
              offers={offers}
              view={"offers"}
              text={
                searchEnded &&
                Array.isArray(offers) &&
                offers.length > 0 &&
                Array.isArray(offers[0].MarketingActions) &&
                offers[0].MarketingActions.length > 0 &&
                offers[0].MarketingActions[0].checkinfo
                  ? offers[0].MarketingActions[0].checkinfo
                  : "suche beste Hotelangebote" + searchcity
              }
            />
            <br />
            <div style={{ display: "flex" }}>
              <div className="offerview4">
                {Array.isArray(offersSorted) && offersSorted.length > 0 && (
                  <span className="offerview5">
                    {offersSorted.length} Ergebnisse zwischen{" "}
                    {nf.format(minPrice)} € und {nf.format(maxPrice)} €{" "}
                  </span>
                )}
              </div>
              {Array.isArray(offersForPage) &&
                offersForPage.length === 0 &&
                loading < 1 && (
                  <span>
                    Es wurden keine Angebote zu Ihrer Auswahl gefunden.
                  </span>
                )}

              <div style={{ flexGrow: 1, justifyContent: "end" }}></div>
              {showSearch && (
                <div>
                  Ort/Hotel&nbsp;&nbsp;
                  <input
                    style={{ width: "200px", marginRight: "20px" }}
                    value={offerlistfilter ? offerlistfilter : ""}
                    onChange={(e) =>
                      dispatch(setOfferlistfilter(e.target.value))
                    }
                  />
                </div>
              )}
              {Array.isArray(offersSorted) && offersSorted.length > 0 && (
                <FaSearch
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() => setShowSearch(!showSearch)}
                />
              )}
              <br />
            </div>
          </div>
          {offersForPage.map((offer, idx) => {
            let stopperpre = <></>;
            let stopperpost = <></>;
            for (let i = 0; i < offerstopper.length; i++) {
              if (
                ((offerstopper[i].row === "first" && idx === 0) ||
                  (offerstopper[i].row === "last" && idx === PAGESIZE - 1) ||
                  offerstopper[i].row === idx + 1) &&
                (offerstopper[i].page === "all" ||
                  (offerstopper[i].page === "first" && offerPage === 1) ||
                  (offerstopper[i].page === "odd" && offerPage % 2 !== 0) ||
                  (offerstopper[i].page === "even" && offerPage % 2 == 0))
              ) {
                if (offerstopper[i].row === "last") {
                  stopperpost = (
                    <div
                      onClick={(e) => dangerButtonHandler(e, 0)}
                      dangerouslySetInnerHTML={{
                        __html: offerstopper[i].desktophtml,
                      }}
                    />
                  );
                } else {
                  stopperpre = (
                    <div
                      onClick={(e) => dangerButtonHandler(e, 0)}
                      dangerouslySetInnerHTML={{
                        __html: offerstopper[i].desktophtml,
                      }}
                    />
                  );
                }
              }
            }
            return (
              <React.Fragment key={idx}>
                {stopperpre}
                <div
                  key={offer.OfferID}
                  className={
                    offer.topseller ? "offerview6topseller" : "offerview6"
                  }
                >
                  <OfferFrame
                    offer={offer}
                    geodata={geodata}
                    hotels={hotels}
                    offerInfos={offerInfos}
                    setHotelIndex={(hotelID) => {
                      for (let i = 0; i < hotels.Hotel.length; i++) {
                        if (hotelID === hotels.Hotel[i].HotelID) {
                          setHotelIdx(i);
                          break;
                        }
                      }
                    }}
                  />
                </div>
                {stopperpost}
              </React.Fragment>
            );
          })}
          {offersSorted.length > PAGESIZE && (
            <div className="offerview8">
              <div className="offerview10">
                {offerPage !== 1 && (
                  <span
                    className="offerview11"
                    onClick={() => dispatch(setOfferPage(offerPage - 1))}
                  >
                    vorherige Seite
                  </span>
                )}
              </div>
              <div className="offerview14">
                <div className="offerview12">
                  {offerPage > 5 &&
                    Math.ceil(offersSorted.length / PAGESIZE) > 10 && (
                      <span onClick={() => dispatch(setOfferPage(1))}>
                        &nbsp;&nbsp;<span className="offerview9 ">1</span>
                        &nbsp;&nbsp;|&nbsp;&nbsp;...&nbsp;&nbsp;|
                      </span>
                    )}
                  {Array.from(
                    Array(
                      Math.ceil(Math.min(offersSorted.length / PAGESIZE, 10))
                    ).keys(),
                    Math.ceil(offersSorted.length / PAGESIZE) < offerPage + 10
                      ? (x) =>
                          x +
                          (Math.ceil(offersSorted.length / PAGESIZE) -
                            Math.ceil(
                              Math.min(offersSorted.length / PAGESIZE, 9)
                            ))
                      : offerPage < 6
                      ? (x) => x
                      : (x) => x + offerPage - 5
                  ).map((e, i) => {
                    /*console.log(
                      Array.from(
                        Array(
                          Math.ceil(Math.min(offers.length / PAGESIZE, 10))
                        ).keys()
                      )
                    );*/
                    if (
                      i === 9 ||
                      i === Math.ceil(offersSorted.length / PAGESIZE) - 1
                    ) {
                      return (
                        <React.Fragment key={i}>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => dispatch(setOfferPage(e + 1))}
                          >
                            &nbsp;&nbsp;
                            <span
                              className={
                                "offerview9 " +
                                (offerPage == e + 1 ? "offerviewhighlight" : "")
                              }
                              onClick={() => dispatch(setOfferPage(e + 1))}
                            >
                              {e + 1}
                              {(e + 1) % 20 === 0 ? <br /> : null}
                            </span>
                            &nbsp;&nbsp;
                          </span>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <React.Fragment key={i}>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => dispatch(setOfferPage(e + 1))}
                          >
                            &nbsp;&nbsp;
                            <span
                              className={
                                "offerview9 " +
                                (offerPage == e + 1 ? "offerviewhighlight" : "")
                              }
                            >
                              {e + 1}
                              {(e + 1) % 20 === 0 ? <br /> : null}
                            </span>
                            &nbsp;&nbsp;
                            <span>|</span>
                          </span>
                        </React.Fragment>
                      );
                    }
                  })}
                </div>
              </div>
              <div className="offerview10">
                {offerPage !== Math.ceil(offersSorted.length / PAGESIZE) && (
                  <span
                    className="offerview13"
                    onClick={() => dispatch(setOfferPage(offerPage + 1))}
                  >
                    nächste Seite
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {hotels &&
        hotels.Hotel[hotelIdx] &&
        hotelIdx > -1 &&
        hotels.Hotel[hotelIdx].HotelGeoPoint && (
          <>
            <GeoSearch />
            <ReactMap
              setNorthEast={(ne) => dispatch(setNorthEast(ne))}
              setSouthWest={(sw) => dispatch(setSouthWest(sw))}
              center={{
                lat: hotels.Hotel[hotelIdx].HotelGeoPoint.Latitude,
                lng: hotels.Hotel[hotelIdx].HotelGeoPoint.Longitude,
              }}
              visible={map}
              closeMap={() => dispatch(setMap(false))}
              markers={[hotels.Hotel[hotelIdx]].map((e) => {
                return {
                  position: {
                    lat: e.HotelGeoPoint
                      ? e.HotelGeoPoint.Latitude
                      : hotels.Hotel[hotelIdx].HotelGeoPoint.Latitude,
                    lng: e.HotelGeoPoint
                      ? e.HotelGeoPoint.Longitude
                      : hotels.Hotel[hotelIdx].HotelGeoPoint.Longitude,
                  },
                  label: e.Name,
                  id: e.HotelID,
                  iataCode: e.HotelID,
                };
              })}
            />
          </>
        )}
    </div>
  );
}
